import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';
import headerStyle from '../../../components/header/style';
import Box from '../../../components/box/Box';
import Heading from '../../../components/typography/heading/Heading';
import Text from '../../../components/typography/text/Text';
import HorizontalScroller from '../../../components/horizontal-scroller';
import Button from '../../../components/button';
import Portal from 'preact-portal';
import CoursesBlocks from '../data/courses.json';
import DownCaret from '../../../assets/images/down-caret.png';
import arrow from '../../../assets/images/arrow-down.svg'

const Popup = ({ open, into="body", children, closeModal }) => (
  <Portal into={into}>
      <div class={open ? [style.modalOverlay, style.modalOverlayToggled].join(' ') : style.modalOverlay} onClick={e => {
        e.stopPropagation();
        closeModal()
      }}>
        <div class={open ? [style.modal, style.modalToggled].join(' ') : style.modal} onClick={e => {
          e.stopPropagation();
        }}>
          { children }
        </div>
      </div>
    </Portal>
);
const CloseButton = ({onClick}) => (
  <button class={style.closeButton} onClick={onClick}>
  </button>
)
const VideoModal = ({title, longDescription, url, buyUrl, closeModal}) => (
  <div class={style.videoModal}>
    <div class={style.videoTopBar}>
      <Heading
        size='sm'
        fontWeight='bold'
        accessibilityLevel={4}>
          {title}
      </Heading>
      <CloseButton onClick={closeModal} />
    </div>
    <iframe
      src={url}
      id="viewerIframe"
      allowfullscreen=""
      webkitallowfullscreen=""
      class={style.popUpVideo}
    ></iframe>
    <div class={style.videoBottomBar}>
      <div class={style.videoDescription}>
        <Text>
          {longDescription}
        </Text>
      </div>
      <Button href={buyUrl}>
        购买课程
      </Button>
    </div>
  </div>
)
const ReviewModal = ({name, school, content, closeModal}) => (
  <div class={style.reviewModal}>
    <div class={style.reviewTopBar}>
      <div />
      <CloseButton onClick={closeModal} />
    </div>
    <div class={style.reviewContentModal}>
      <Box direction='column' marginBottom='10px'>
        <Text>
          {name}
        </Text>
        <Text size='sm'>
          {school}
        </Text>
      </Box>
      <Text>
        {content}
      </Text>
    </div>
  </div>
)

class HeaderItem extends Component {
    render(){
        const items = CoursesBlocks;
        const displayItem = items.map((item, index) => {
                return (
                    <div key={index} class={style.singleItem}>
                        <div class={style.tooltip}>
                            {item.title}
                            <span class={style.tooltiptext}>
                            <div class={style.courseTitle}>
                             {item.courses.map((content, cIndex) => {
                                 return (
                                     <a key={cIndex} class={style.courseContent} style="margin: 0 0 0 0; height: 55px" href={`/courses/${index}/${cIndex}`}>
                                         <p class={style.courseText}>{content.title}</p>
                                     </a>
                                 );
                             })}
                             </div>
                         </span>
                        </div>
                        <img src={arrow} class={style.icon}></img>
                    </div>
                );
            }
        );
        return (
            <div class={style.items}>
                {displayItem}
            </div>
        );
    }

}

class StickyHeader extends Component {
  componentDidMount() {
    this.rAF = window.requestAnimationFrame	||
      window.webkitRequestAnimationFrame	||
      window.mozRequestAnimationFrame		||
      window.oRequestAnimationFrame		||
      window.msRequestAnimationFrame		||
      function (callback) { window.setTimeout(callback, 1000 / 60); };

    this.rAF = this.rAF ? this.rAF.bind(window) : this.rAF;
    this.scrollTo = this.scrollTo.bind(this);
    //this.previewLinkPos = this.previewLink.getBoundingClientRect().left;
  }

  componentDidUpdate(prevProps) {
    if(prevProps.previewToggled != this.props.previewToggled) {
      if(this.props.previewToggled) {
        this.scrollTo(this.previewLinkPos,600);
      } else {
        this.scrollTo(0,600);
      }
    }
  }
  easeInOutQuad(t, b, c, d) {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
  }

  scrollTo(to, duration) {
    let start = this.stickyPageLinks.scrollLeft,
        change = to - start,
        currentTime = Date.now()

    let animateScroll = () => {
        const millis = Date.now() - currentTime;
        const val = this.easeInOutQuad(millis, start, change, duration);
        this.stickyPageLinks.scroll(val, 0);
        if(millis < duration) {
            this.rAF(animateScroll)
        }
    };
    this.rAF(animateScroll);
  }
  render({blockIndex, courseIndex, buyUrl, stickyToggled, previewToggled}) {
    return (
      <div class={stickyToggled ? [headerStyle.header, style.stickyMenu, style.stickyMenuToggled].join(' ') : [headerStyle.header, style.stickyMenu].join(' ')}>
        <nav>
          <div class={style.stickyPageLinks} ref={node => this.stickyPageLinks = node}>
              <div class={style.headerDisplay}>
                  <HeaderItem/>
              </div>
          </div>
          <a class={style.buyCourse} href={buyUrl} target="_blank">购买课程</a>
        </nav>
      </div>
    )
  }
}

export default class Course extends Component {
  state = {
    modalOpen: false,
    modalType: '',
    modalProps: {},
    stickyToggled: false,
    previewNavToggled: false,
  }
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.escapeKeyPressed = this.escapeKeyPressed.bind(this);
    this.toggleStickyPadding = this.toggleStickyPadding.bind(this);
    this.togglePreviewActive = this.togglePreviewActive.bind(this);
  }
	componentDidMount() {
    //this.previewScreenPos = this.preview.getBoundingClientRect().top;
    window.addEventListener('keydown', this.escapeKeyPressed, false);
    window.addEventListener('scroll', this.toggleStickyPadding, false);
    window.addEventListener('scroll', this.togglePreviewActive, false);
    this.toggleStickyPadding();
    this.togglePreviewActive();
	}
	componentWillUnmount() {
    window.removeEventListener('keydown', this.escapeKeyPressed, false)
    window.removeEventListener('scroll', this.toggleStickyPadding, false)
    window.removeEventListener('scroll', this.togglePreviewActive, false)
	}
  escapeKeyPressed(e) {
    if(e.key === 'Escape') {
      this.closeModal()
    }
  }
  openModal(type, props) {
    this.setState({
      modalOpen: true,
      modalType: type,
      modalProps: props
    })
  }
  closeModal() {
    this.setState({
      modalOpen: false
    })
  }

  togglePreviewActive() {
    if(window.scrollY >= this.previewScreenPos-60) {
      this.setState({
        previewNavToggled: false
      })
    } else {
      this.setState({
        previewNavToggled: false
      })
    }
  }

  toggleStickyPadding() {
    if(window.scrollY >= 140) {
      this.setState({
        stickyToggled: true
      })
    } else {
      this.setState({
        stickyToggled: false
      })
    }
  }

	render({matches}, {modalOpen, modalType, modalProps, stickyToggled, previewNavToggled}) {
		const widthProps = {
			maxWidth: '580px',
			width: '100%',
		}
		const containerProps = {
			paddingX: '20px',
			paddingY: '35px',
			justify: 'center'
		}
    const {blockIndex, courseIndex} = matches;
    const course = CoursesBlocks[parseInt(blockIndex,10)].courses[parseInt(courseIndex,10)];
    const reviewGenerator = (inlineStyle) => course.reviews.map(r => {
      const content = r.content.length >= 125 ? `${r.content.substring(0, 125).trim()}...` : r.content;
      return (
        <div style={inlineStyle} class={style.reviewCard} onClick={() => this.openModal('review', r)}>
          <Box marginBottom='10px' direction='column'>
            <Text>
              {r.name}
            </Text>
            <Text size='sm'>
              {r.school}
            </Text>
          </Box>
          <Text>
            {content}
          </Text>
          <div class={style.readMore}>
            阅读更多
            <img src={DownCaret} class={style.downCaret}/>
          </div>
        </div>
      )
    })
    const videoGenerator = (inlineStyle) => course.videos.map(v => {
      return (
        <div style={inlineStyle} class={style.videoCard} onClick={() => this.openModal('video', v)}>
          <div class={style.videoPreview}>
            <svg width="48px" height="47px" viewBox="0 0 48 47" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <defs></defs>
                <g id="Final-Screens" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Desktop-Final-Prototype-3" transform="translate(-526.000000, -3583.000000)">
                        <g id="Video-Sample-1" transform="translate(394.000000, 3515.000000)">
                            <g id="Group-8" transform="translate(132.804194, 68.266826)">
                                <circle id="Oval-2" fill="#EEEEEE" cx="23.2781245" cy="23.2781245" r="23.2781245"></circle>
                                <polygon id="Triangle" fill="#D8D8D8" points="32.664465 23.2781245 17.6463201 32.2890113 17.6463201 14.2672376"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <img src={`/static/courses/${v.previewImg}`} alt={v.previewAlt}/>
          </div>
          <div class={style.videoData}>
            <Heading size='md' accessibilityLevel={4}>
              {v.title}
            </Heading>
            <Text>
              {v.shortDescription}
            </Text>
          </div>
        </div>
      )
    })
		return (
			<div class={style.course}>
        <Popup open={modalOpen} closeModal={this.closeModal}>
          {
            modalType === 'video'
            ? <VideoModal {...modalProps} buyUrl={course.buyUrl} closeModal={this.closeModal}/>
            : <ReviewModal {...modalProps} closeModal={this.closeModal}/>
          }
        </Popup>
        <StickyHeader blockIndex={blockIndex} courseIndex={courseIndex} buyUrl={course.buyUrl} stickyToggled={stickyToggled} previewToggled={previewNavToggled}/>
				<Box {...containerProps} align='center'>
					<Box maxWidth='580px' width='100%' justify='center' align='center' direction='column'>
						<Heading size='lg' accessibilityLevel={1}>{course.title}</Heading>
					</Box>
				</Box>
        <a name='preview' ref={node => this.preview = node}/>
        <Box
          {...containerProps}
          color={course.blocks.length % 2 == 0 ? 'white' : 'gray'}
          direction='column'
          align='center'
          className={style.scrollerContainer}>
                <HorizontalScroller
                    itemsGenerator={videoGenerator}
                    itemsLength={course.videos.length}
                    gutterWidth={1.5}
                />
        </Box>
        {/*
        <Box
          {...containerProps}
          color={course.blocks.length % 2 == 0 ? 'white' : 'gray'}
          direction='column'
          align='center'
          className={style.scrollerContainer}>
          <HorizontalScroller
            itemsGenerator={reviewGenerator}
            itemsLength={course.reviews.length}
            gutterWidth={1.5}
          />
        </Box>
        */}
        {
          course.blocks.map((b, index) => {
            return (
              <Box {...containerProps} color={index == 3 ? 'white' : 'gray'} direction='column' align='center'>
                <Box {...widthProps} direction='column' align='left'>
                  <Heading size='md' accessibilityLevel={2}>{b.title}</Heading>
                </Box>
                  <div class={style.classContent}>
                      <Box {...widthProps} marginTop='10px' display="flex">
                          <Text columnCount={index == 3 ? 2: 1} columnGap={index == 3 ? 60 : 0}>
                              {b.content}
                          </Text>
                      </Box>
                  </div>
                  <div class={style.classContentMobile}>
                      <Box {...widthProps} marginTop='10px' display="block">
                          <Text>
                              {b.content}
                          </Text>
                      </Box>
                  </div>

              </Box>
            )
          })
        }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./routes/courses/course/index.js